(function() {

    document.addEventListener('DOMContentLoaded', function() {

        // Try immediate initialization if FlavorPicker is already loaded
        if (typeof FlavorPicker === 'function') {
            initializeBlockFlavor();
        } else {
            // Set up multiple ways to detect when FlavorPicker becomes available

            // Option 1: Wait for flavor-picker:loaded event
            document.addEventListener('flavor-picker:loaded', function() {
                // console.log('🍦 flavor-picker:loaded event detected');
                initializeBlockFlavor();
            });

            // Option 2: Poll for FlavorPicker class
            let attempts = 0;
            const maxAttempts = 50;
            const checkInterval = 100; // ms

            const checkForFlavorPicker = setInterval(function() {
                attempts++;
                if (typeof FlavorPicker === 'function') {
                    clearInterval(checkForFlavorPicker);
                    initializeBlockFlavor();
                } else if (attempts >= maxAttempts) {
                    clearInterval(checkForFlavorPicker);

                    // Final attempt - try to create the class ourselves
                    createBackupFlavorPickerClass();
                }
            }, checkInterval);
        }
    });

    function initializeBlockFlavor() {
        if (window.flavorPickerBlockInstance) {
            return;
        }

        const blockContainer = document.querySelector('.flavor-picker-block');

        if (!blockContainer) {
            console.error('🍦 Block container not found!');
            return;
        }

        try {
            window.flavorPickerBlockInstance = new FlavorPicker('.flavor-picker-block');

            // Force an update to make sure UI reflects current state
            setTimeout(function() {
                if (window.flavorPickerBlockInstance) {
                    window.flavorPickerBlockInstance.validatePack();
                    window.flavorPickerBlockInstance.updateFlavorItemQuantities();
                }
            }, 500);
        } catch (error) {
            console.error('🍦 Error creating FlavorPicker instance:', error);
        }
    }

    function createBackupFlavorPickerClass() {

        if (typeof FlavorPicker !== 'function') {
            window.FlavorPicker = function(containerSelector) {
                this.containerSelector = containerSelector;
                this.isBlockVersion = containerSelector === '.flavor-picker-block';
                this.pack = {
                    sizes: [6, 12],
                    activeSize: 6,
                    items: []
                };
                this.elements = {};
                this.cacheElements();
                this.setupBasicEvents();
                this.updateUI();

                // Store instance
                if (this.isBlockVersion) {
                    window.flavorPickerBlockInstance = this;
                }
            };

            // Basic methods
            FlavorPicker.prototype.cacheElements = function() {
                const container = document.querySelector(this.containerSelector);
                if (!container) return;

                this.elements = {
                    container: container,
                    flavorItems: container.querySelectorAll('.flavor-item, .flavor-item-block'),
                    packSizeButtons: container.querySelectorAll('.pack-size'),
                    packSlots: container.querySelector('.pack-slots'),
                    addToCartBtn: container.querySelector('.add-to-cart-btn'),
                    clearAllBtn: container.querySelector('.clear-all-btn')
                };
            };

            FlavorPicker.prototype.setupBasicEvents = function() {
                if (!this.elements.container) return;

                // Set up click handlers for flavor items
                this.elements.flavorItems?.forEach(item => {
                    const increaseBtn = item.querySelector('.increase-qty');
                    const decreaseBtn = item.querySelector('.decrease-qty');

                    increaseBtn?.addEventListener('click', (e) => {
                        e.stopPropagation();
                        this.updateItemQuantity(item, 1);
                    });

                    decreaseBtn?.addEventListener('click', (e) => {
                        e.stopPropagation();
                        this.updateItemQuantity(item, -1);
                    });
                });

                // Clear all button
                this.elements.clearAllBtn?.addEventListener('click', () => {
                    this.pack.items = [];
                    this.updateUI();
                });
            };

            FlavorPicker.prototype.updateItemQuantity = function(itemElement, delta) {
                const productId = itemElement.dataset.productId;
                if (!productId) return;

                const productTitle = itemElement.dataset.productTitle || 'Unknown Flavor';
                const imageElements = itemElement.querySelectorAll('.flavor-image');
                const imageUrl = imageElements[0] ? imageElements[0].src : '';
                const imageUrlLifestyle = imageElements[1] ? imageElements[1].src : '';
                const sku = itemElement.dataset.sku || 'Unknown SKU';

                // Find existing item
                let found = false;
                for (let i = 0; i < this.pack.items.length; i++) {
                    if (this.pack.items[i].id === productId) {
                        // Update quantity
                        this.pack.items[i].quantity += delta;

                        // Remove if quantity becomes 0
                        if (this.pack.items[i].quantity <= 0) {
                            this.pack.items.splice(i, 1);
                        }

                        found = true;
                        break;
                    }
                }

                // Add new item if not found and delta is positive
                if (!found && delta > 0) {
                    this.pack.items.push({
                        id: productId,
                        imageUrl,
                        imageUrlLifestyle,
                        quantity: delta,
                        sku,
                        title: productTitle,
                    });
                }

                this.updateUI();
            };

            FlavorPicker.prototype.updateUI = function() {
                // Update quantity displays
                this.elements.flavorItems?.forEach(itemElement => {
                    const productId = itemElement.dataset.productId;
                    const quantityElement = itemElement.querySelector('.quantity-value');
                    const decreaseBtn = itemElement.querySelector('.decrease-qty');

                    // Find matching item
                    const packItem = this.pack.items.find(i => i.id === productId);
                    const quantity = packItem ? packItem.quantity : 0;

                    // Update display
                    if (quantityElement) quantityElement.textContent = String(quantity);
                    if (decreaseBtn) decreaseBtn.disabled = (quantity <= 0);
                });

                // Render pack slots
                this.renderPackSlots();

                this.updateButtons();
            };

            FlavorPicker.prototype.renderPackSlots = function() {
                const packSlots = this.elements.packSlots;
                if (!packSlots) return;

                // Clear slots
                packSlots.innerHTML = '';

                const totalQuantity = this.getTotalQuantity();
                const activeSize = this.pack.activeSize;

                // Create slots
                for (let i = 0; i < activeSize; i++) {
                    const slot = document.createElement('div');
                    slot.className = 'pack-slot';
                    slot.role = "button";

                    if (i < totalQuantity) {
                        slot.classList.add('filled');
                        slot.innerHTML = '<div class="slot-container"><div style="background-color:#ccc;width:100%;height:100%;border-radius:50%;"></div></div>';
                    } else {
                        slot.innerHTML = '<div class="slot-container"><div style="width:100%;height:100%;border-radius:50%;border:2px dashed #ccc;"></div></div>';
                    }

                    packSlots.appendChild(slot);
                }
            };

            FlavorPicker.prototype.updateButtons = function() {
                const totalQuantity = this.getTotalQuantity();

                // Update clear button
                if (this.elements.clearAllBtn) {
                    this.elements.clearAllBtn.disabled = (totalQuantity === 0);
                }

                // Update add to cart button
                if (this.elements.addToCartBtn) {
                    const activeSize = this.pack.activeSize;

                    if (totalQuantity === 0) {
                        this.elements.addToCartBtn.textContent = `Add ${activeSize} pints`;
                        this.elements.addToCartBtn.disabled = true;
                    } else if (totalQuantity < activeSize) {
                        const needed = activeSize - totalQuantity;
                        this.elements.addToCartBtn.textContent = `Add ${needed} more pint${needed !== 1 ? 's' : ''}`;
                        this.elements.addToCartBtn.disabled = true;
                    } else if (totalQuantity === activeSize) {
                        this.elements.addToCartBtn.textContent = 'Add Pack to Cart';
                        this.elements.addToCartBtn.disabled = false;
                    } else {
                        this.elements.addToCartBtn.textContent = 'Adjust Quantity';
                        this.elements.addToCartBtn.disabled = true;
                    }
                }
            };

            FlavorPicker.prototype.getTotalQuantity = function() {
                return this.pack.items.reduce((sum, item) => sum + item.quantity, 0);
            };
        }

        initializeBlockFlavor();
    }
})();